import * as React from "react";
const SvgFiRrPipeSmoking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pipe-smoking_svg__a)">
      <path
        fill="#062147"
        d="M23 0c-1.22 0-2.362.6-3.057 1.604l-6.568 9.498a3.04 3.04 0 0 0-3.193 1.158l-.662.983-.15-.67a1.99 1.99 0 0 0-1.948-1.563l-4.61-.008h-.004c-.93 0-1.75.657-1.952 1.563l-.1.445c-.39 1.729-.758 3.361-.756 6.011C.003 21.766 2.245 24 5 24h1.055a6.74 6.74 0 0 0 5.521-2.888l3.543-5.354a2.985 2.985 0 0 0-.078-3.552l6.547-9.466A1.72 1.72 0 0 1 23 2a1 1 0 1 0 0-2m-9.535 14.635-3.542 5.352a4.73 4.73 0 0 1-3.868 2.014H5c-1.652 0-2.999-1.337-3-2.98-.002-2.427.326-3.883.706-5.568l.101-.449 4.61.007.098.438c.188.834.365 1.621.496 2.505a1.001 1.001 0 0 0 1.819.413l1.984-2.949a1.03 1.03 0 0 1 1.394-.242c.231.154.388.39.438.663.052.273-.007.55-.181.799z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pipe-smoking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPipeSmoking;
